export const ERRORS = {
    PAGE_NOT_FOUND: 'Page not found',
}
